import { supabase } from "@/lib/supabase/supabaseClient";
import { useChangeValidStatusProps } from ".";

export const changeValidStatus = async ({response_id, is_valid, selected_user_id}:useChangeValidStatusProps) => {
    const res = await supabase.rpc('change_valid_status', {response_id, is_valid, selected_user_id})
    // console.log(res)
    return res; 
}